import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';
import React, { Suspense, useMemo } from 'react';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';

import {
  RECOVERY_WINDOW_DAYS,
  RegenerateNotesTable,
} from './RegenerateNotesTable';

const RegenerateNotesContent: React.FC = () => {
  const tenantId = useAssignedTenantIdFromParams();

  // Computed here (the page does not suspend) and truncated to the start of the
  // day so it stays stable across the table's suspense retries.
  const since = useMemo(
    () => startOfDay(subDays(new Date(), RECOVERY_WINDOW_DAYS)).toISOString(),
    [],
  );

  return (
    <Suspense fallback={<TableSkeleton rowCount={10} />}>
      <RegenerateNotesTable tenantId={tenantId} since={since} />
    </Suspense>
  );
};

export const RegenerateNotesPage: React.FC = () => (
  <SettingsPageFrame
    size="wide"
    title="Note Recovery"
    description={
      <>
        Regenerate clinical notes for appointments where the note failed, was
        never generated, or is stuck. Only appointments from the last 7 days are
        shown &mdash; notes older than that can&rsquo;t be regenerated here.
        Appointments with a signed note are excluded; turn on &ldquo;Show
        appointments with notes&rdquo; to also include ones that already have an
        unsigned draft.
      </>
    }
  >
    <RegenerateNotesContent />
  </SettingsPageFrame>
);
